'use strict';

ngtk.model.Factory = Class({

    $injector: undefined,
    _modelsContainer: undefined,

    construct: function($injector, modelsContainer) {
        this.$injector = $injector;
        this._modelsContainer = modelsContainer;
    },

    create: function(modelClassOrName, args) {
        var modelClass;
        if (this._modelsContainer && angular.isString(modelClassOrName)) {
            modelClass = this._modelsContainer[modelClassOrName];
        } else {
            modelClass = modelClassOrName;
        }
        if (!angular.isFunction(modelClass)) {
            throw new Error("Invalid argument: " + modelClassOrName);
        }
        return this.$injector.instantiate(modelClass, args);
    }

});
